import { render } from "./AddIndispo.vue?vue&type=template&id=79008009"
import script from "./AddIndispo.vue?vue&type=script&lang=ts"
export * from "./AddIndispo.vue?vue&type=script&lang=ts"

import "./AddIndispo.vue?vue&type=style&index=0&id=79008009&lang=scss"
script.render = render

export default script